// Matches the notice branch of build60; editors retain their existing shell.
export const isNoticeReader = (path) =>
  /^\/notice(?:\/(?!create(?:\/|$))[^/]+(?:\/comment\/\d+)?)?\/?$/.test(path);
